'use strict';

import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin( ScrollTrigger );

import Swiper from 'swiper';
import SwiperCore, { EffectFade, Parallax, Autoplay, Navigation } from 'swiper/core';
SwiperCore.use( [
    EffectFade,
    Parallax,
    Autoplay,
    Navigation,
] );

import 'select2';
import 'jquery.nicescroll';

// import Axeptio from './axeptio';
import CookieNotice from './cookie-notice';
import CustomFilters from './custom-filters';
import FrontPage from './frontpage';
import Gutenberg from './gutenberg';
import HeaderSticky from './header-sticky';
import History from './history';
import InnerNav from './inner-nav';
import MenuSticky from './menu-sticky';
import Numbers from './numbers';
import PageJobs from './page-jobs';
import PageOrganizationChart from './page-organization-chart';
import Popin from './popin';
import SearchPopin from './search-popin';
import Select2 from './select2';
import SingleFicheAdherent from './single-fiche-adherent';
import SmoothScroll from './smooth-scroll';
import SocialsSharer from './socials-sharer';
import ContactAdherent from './contact-adherent';
import BubbleSmoothScroll from './bubble-smooth-scroll';
import Gauge from './gauge';
import SliderIntegrate from './slider-integrate';
import SliderTestimonials from './slider-testimonials';
import Tracking from './tracking';
import Embed from './embed';

// Axeptio();
CookieNotice();
CustomFilters();
FrontPage();
Gutenberg();
HeaderSticky();
History();
InnerNav();
MenuSticky();
Numbers();
PageJobs();
PageOrganizationChart();
Popin();
SearchPopin();
Select2();
SingleFicheAdherent();
SmoothScroll();
SocialsSharer();
ContactAdherent();
BubbleSmoothScroll();
Gauge();
SliderIntegrate();
SliderTestimonials();
Embed.init();
Tracking.init();


const jQuery = window.jQuery;
window._axcb = window._axcb || [];
